import { useCallback, useMemo } from 'react';
import { nanoid } from 'nanoid';
function preventDefault(event) {
  event.preventDefault();
}
/**
 * Returns props to associate a form with a submit button. It generates a unique
 * id that will be assigned to the form `id` attribute and a button `form`
 * attribute. Useful for cases where a submit button exists outside of the form.
 *
 * e.g.
 *
 * const preventDefaultFormSubmit = true;
 * const { formProps, submitButtonProps } = useFormWithDetachedSubmitButton(preventDefaultFormSubmit);
 *
 * <form {...formProps}></form>
 * <button {...submitButtonProps} type="submit">Submit</button>
 *
 * @param enableDefaultFormSubmitBehavior Optionally enable default form submit behavior.
 * @returns props that can be spread on a form component + a submit button component.
 */
export default function useFormWithDetachedSubmitButton() {
  var enableDefaultFormSubmitBehavior = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var formId = useMemo(() => "useSubmitButtonRef-".concat(nanoid()), []);
  var submitButtonRef = useCallback(buttonEl => {
    var _buttonEl$UNSAFE_getD;
    buttonEl === null || buttonEl === void 0 || (_buttonEl$UNSAFE_getD = buttonEl.UNSAFE_getDOMNode()) === null || _buttonEl$UNSAFE_getD === void 0 || _buttonEl$UNSAFE_getD.setAttribute('form', formId);
  }, [formId]);
  var formProps = useMemo(() => ({
    id: formId,
    onSubmit: enableDefaultFormSubmitBehavior ? undefined : preventDefault
  }), [formId, enableDefaultFormSubmitBehavior]);
  var submitButtonProps = useMemo(() => ({
    form: formId,
    ref: submitButtonRef
  }), [formId, submitButtonRef]);
  return {
    formProps,
    submitButtonProps
  };
}
//# sourceMappingURL=useFormWithDetachedSubmitButton.js.map